<template>
    <div>
        <div class="vx-card px-6 py-2">
            <div class="vx-row">
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full">
                    <label class="vs-input--label">Chi nhánh</label>
                    <v-select class="w-full" v-model="selectedBranch" :options="branchOptions"
                              :clearable="false"></v-select>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full md:mt-0 mt-2">
                    <label class="vs-input--label">Phòng ban</label>
                    <v-select class="w-full" v-model="selectedDepartment" :options="departmentOptions"
                              :clearable="false"></v-select>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full lg:mt-0 mt-2">
                    <label class="vs-input--label">Tìm kiếm</label>
                    <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm theo tên hoặc mã"
                              v-on:keyup.enter="filter"></vs-input>
                </div>
                <div class="vx-col lg:w-1/4 sm:w-1/2 w-full lg:mt-0 md:mt-2">
                    <vs-button class="mt-6" iconPack="feather" icon="icon-search" color="primary"
                               @click="getAllDataService">Tìm kiếm
                    </vs-button>
                </div>
                <div class="vx-col w-full md:mt-0">
                    <div class="w-full flex flex-wrap">
                        <vs-button class="mt-4" @click="$router.push('/user/info-service-type')" color="primary"
                                   icon-pack="feather" icon="icon-plus" v-if="isPermissionCreateService">
                            Thêm mới nhóm dịch vụ
                        </vs-button>
                        <vs-button @click="downloadFileSample" type="border" color="primary" icon-pack="feather"
                                   icon="icon-download"
                                   class="mt-4 ml-2">
                            Tải xuống tệp mẫu
                        </vs-button>
                        <vs-button @click="$refs.fileUpload.click()" type="border" color="warning" icon-pack="feather"
                                   icon="icon-upload" class="mt-4 ml-2" v-if="isPermissionImportService">
                            Tải lên tệp nhóm dịch vụ
                        </vs-button>
                        <vs-button @click="downloadFileExcel" type="border" color="primary" icon-pack="feather"
                                   icon="icon-download" class="mt-4 ml-2" v-if="isPermissionExportService">
                            Xuất excel tệp nhóm dịch vụ
                        </vs-button>
                        <vs-button @click="synchronized" type="border" color="primary" icon-pack="feather"
                                   icon="icon-repeat" class="mt-4 ml-2" >
                            Đồng bộ
                        </vs-button>
                        <input ref="fileUpload" type="file" id="fileUpload" accept=".xlsx, .xls, .csv, .xlsm, .xlsb"
                               class="hidden" @change="uploadFile($event)" v-if="isPermissionImportService">
                    </div>
                </div>
            </div>

            <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                         class="ag-theme-material w-100 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="serviceTypeData" :animateRows="true" :pagination="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <div class="mt-4 flex flex-wrap" v-if="serviceTypeData.length > 0">
                <div class="">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 flex flex-wrap">
                        <span class="my-auto mr-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        serviceTypeData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : serviceTypeData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="sm:ml-auto">
                    <vs-pagination class="" :total="totalPages" v-model="currentPage" @change="loadPage"/>
                </div>
            </div>
        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp nhân viên" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" pagination max-items="10">
                        <template slot="thead">
                            <vs-th> STT</vs-th>
                            <vs-th> Trường dữ liệu</vs-th>
                            <vs-th> Hàng</vs-th>
                            <vs-th> Cột</vs-th>
                            <vs-th> Lỗi</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Pagination from "../../../ui-elements/Pagination.vue";
import authConfig from '../../../../../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {

    data() {
        return {
            branchOptions: [],
            serviceTypeData: [],
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: 'Mã nhóm dịch vụ',
                    field: 'code',
                    width: 100
                },
                {
                    headerName: 'Tên nhóm dịch vụ',
                    field: 'name',
                    width: 200
                },
                {
                    headerName: 'Ghi chú',
                    field: 'description',
                    width: 150,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            selectedBranchValue: null,
            keySearch: null,
            departmentOptions: [],
            selectedDepartmentValue: null,
            popupErrorImport: false,
            errorData: [],
        }
    },

    components: {
        vSelect,
        AgGridVue,
        CellRendererActions,
        Pagination,
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateVipCustomer'(val) {
            if (val) {
                this.getAllDataService();
                this.$store.commit('UPDATE_VIP_CUSTOMER', false);
            }
        }
    },

    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.getDepartment();
            }
        },

        selectedDepartment: {
            get() {
                let obj = this.departmentOptions.find(x => x.value === this.selectedDepartmentValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
            }
        }
    },

    created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        this.getAllDataService();
        this.getDepartment();
    },

    methods: {
        getAllDataService() {
            let payload = {
                keySearch: this.keySearch,
                organizationBranchId: this.selectedBranchValue,
                departmentId: this.selectedDepartmentValue,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }

            this.$vs.loading();
            this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                this.serviceTypeData = res.data.content.map(el => {
                    el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                    return el;
                })
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getDepartment() {
            let body = {
                organizationBranchId: this.selectedBranchValue,
            };

            this.$vs.loading();
            this.$crm.post('/department/find-by-condition', body).then(res => {
                this.departmentOptions = res.data.map(x => {
                    return {
                        value: x.id,
                        label: x.departmentName
                    }
                });

                this.departmentOptions.unshift({value: null, label: 'Tất cả'});
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllDataService();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllDataService();
        },

        isExcel(file) {
            return /\.(xlsx)$/.test(file.name)
        },
        uploadFile(e) {
            let file = [...e.target.files];
            if (!this.isExcel(file[0])) {
                this.$refs.fileUpload.value = null;
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('file', file[0]);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post(`/beauty-service-package/import-excel`, formData).then(res => {
                if (res.data && res.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.map(el => {
                        el.stt = res.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.$vs.notify({
                        text: 'Tải lên tệp nhóm dịch vụ thành công!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    });
                    this.getAllDataService();
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.$refs.fileUpload.value = null;
        },

        downloadFileExcel() {
            let payload = {
                keySearch: this.keySearch,
                organizationBranchId: this.selectedBranchValue,
                departmentId: this.selectedDepartmentValue,
            }

            this.$vs.loading();
            this.$crm.post('/beauty-service-package/export-excel-service', payload).then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Thành công',
                    text: 'Xuất file excel thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        synchronized() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$vs.loading();
            this.$crm.get(`/beauty-service/get-all-from-nano?organizationId=${userInfo.organization.id}` ).then(() => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Thành công',
                    text: 'Quá trình đồng bộ đang được thực hiện. Vui lòng chờ trong giây lát!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        downloadFileSample() {
            this.$vs.loading();
            this.$crm.get('/beauty-service-package/download-template-import-service').then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        filter() {
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllDataService();
        },

        isPermissionCreateService() {
            return isAPI(this, constAPI.beauty_service_create);
        },

        isPermissionImportService() {
            return isAPI(this, constAPI.beauty_service_import);
        },

        isPermissionExportService() {
            return isAPI(this, constAPI.beauty_service_pack_export);
        },
        isPermissionSynchService() {
            return isAPI(this, constAPI.beauty_synch_service);
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },

}
</script>
